import axiosClient from "../axios-client";
import { Account, AccountAdd, AccountEdit } from "../models/account";


export const getAccounts = async ( body: object = {}, sortKey: string = 'id', maxRecords: string = '0', sortMethod: string = 'asc', load: string[] = [], signal?: AbortSignal): Promise<Account[]> => {
    const loadString = `?load=${load.join(',')}`;
    const response = await axiosClient.post(`/api/accounts/search/${maxRecords}/${sortKey}/${sortMethod}${loadString}`, body, {
        signal: signal // Pass the signal to the request options
    });

    return response.data;

}

export const getAccountById = async (id: string | number, signal?: AbortSignal): Promise<Account> => {
    const response = await axiosClient.get(`/api/accounts/${id}`, {
        signal: signal // Pass the signal to the request options
    });

    return response.data;
}

export const getNextAccountNumber = async (accountType: string): Promise<number> => {
    const response = await axiosClient.post(`/api/accounts/next-number`,
        {
            account_type: accountType,
        });
    return response.data.next_account_index;
}

export const addAccount = async (accountToAdd: AccountAdd): Promise<Account> => {
    const response = await axiosClient.post(`/api/accounts`, accountToAdd);
    return response.data;
}

export const saveAccount = async (accountId: number, accountToSave: AccountEdit): Promise<Account> => {
    const response = await axiosClient.patch(`/api/accounts/${accountId}`, accountToSave);
    return response.data;
}

export const deleteAccount = async (accountId: number): Promise<void> => {
    await axiosClient.delete(`/api/accounts/${accountId}`);
}

export const accountRecommendation = async (sortCode: number): Promise<number> => {
    const response = await axiosClient.post(`/api/accounts/recommendation`, {sort_code: sortCode});
    return response.data.recommended_account_number;
}